// import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { EventType, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { initializeIcons } from "@fluentui/react";
import App from "./App.jsx";
import "./index.css";
import { msalConfig } from "./shared/authConfig.js";
import { createSession } from "./shared/backend.js";

initializeIcons();

// initialize MSAL, cf. ./node_modules/@azure/msal-browser/src/app/IPublicClientApplication.ts
export const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize().then(() => {
  console.log("MSAL instance initialized");
  msalInstance.addEventCallback((msg) => {
    console.log("Login successful for account", msg.payload.account);
    msalInstance.setActiveAccount(msg.payload.account);

    console.log("Attempting to create session");
    createSession()
      .then(() => {
        console.log("> Session with backend API created");
        window.location.reload();
      })
      .catch((error) => {
        console.error("> Failed to create session. Reason:", error);
      });
  }, EventType.LOGIN_SUCCESS);
});

// TODO: re-enable StrictMode for prod build. It's disabled for now because it causes
// console logs to be printed twice. Details: https://stackoverflow.com/a/73615145
createRoot(document.getElementById("root")).render(
  // <StrictMode>
  <MsalProvider instance={msalInstance}>
    <App />
  </MsalProvider>
  // </StrictMode>
);
